import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, Tooltip, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { globalGetService, globalPutService, globalPostService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { mtInstance, titanAviInstance } from '../../../shared/components';
const TAOpsReq = ({ params, assetInfoData }) => {
  const [opsReqData, setOpsData] = useState({});
  const [oldData, setOldData] = useState({});
  const [isEdit, setEdit] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [error, setError] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const onFieldChange = (key, value) => { setOpsData({ ...opsReqData, [key]: value }); }
  useEffect(()=>{
    getOpsReq()
  },[])

  const getOpsReq =(query)=>{
      setLoading(true);
      globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/operational_requirements/`, query)
      .then(response=>{
      setLoading(false);
      if(checkApiStatus(response)){
        setOpsData(response.data.data)
      }
    })
  }

  const onEditOpsReq = () => {
        let validationInputs = {}
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, opsReqData)
            globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/operational_requirements/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'Aircraft Aquisition & Other Details', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Aircraft Aquisition & Other Details data from Edit Aircraft Aquisition & Other Details form' });
                        setEdit(false);
                    }
                    setLoading(false);
                })
        } else {
            setError(validationInputs)
        }
    }

  return (
    <div style={{ position: 'relative' }}>
      <div className="console-forms-fields" style={{ height: `${window.innerHeight - (isEdit ? 260 : 215)}px`, padding: '10px', overflow: 'auto' }}>
        <p style={{ textAlign: 'right', height: '20px' }}>
          {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
            <span style={{ cursor: 'pointer' }}>
              <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
            </span> : null
          }
        </p>
        {skeletonLoader ? < STableLoader count={3} size={7} /> : <>
          <Grid container spacing={1}>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='area_navigation'
                label='Area Navigation (BRNAV/PRNAV)'
                value={opsReqData?.area_navigation || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('area_navigation', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='etops_aircraft_model_certification'
                label={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    ETOPS Certification
                    <Tooltip title="Specifiy the Certification Standard.For Eg 60min or 120min or 180min." placement='right'  ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                  </span>
                }
                value={opsReqData?.etops_aircraft_model_certification || ''}
                inputProps={{ maxLength: 255 }}
                fullWidth
                margin="normal"
                onChange={(e) => { onFieldChange('etops_aircraft_model_certification', e.target.value); setError({ ...error, 'acquisition_date': '' }) }}
                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                variant='outlined'
              />
            </Grid>
             <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='instrument_landing'
                label='Instrument Landing Capability'
                value={opsReqData?.instrument_landing || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('instrument_landing', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='noise_category'
                label='Noise Category'
                value={opsReqData?.noise_category || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('noise_category', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='rvsm'
                label={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    Reduced Vertical Separation Minima
                    <Tooltip title="Specifiy 'Complied' or 'Not Complied'" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                  </span>
                }
                value={opsReqData?.rvsm || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('rvsm', e.target.value)}
                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                variant='outlined'
              />
            </Grid>
            {assetInfoData?.aircraft_type?.name.split('-') && assetInfoData?.aircraft_type?.name.split('-')[0] ==='B777'?
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='tailwind_certification'
                label='Tailwind Certification'
                value={opsReqData?.tailwind_certification || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('tailwind_certification', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>:null}
            {assetInfoData?.aircraft_type?.name.split('-') && ['B737','A320'].includes(assetInfoData?.aircraft_type?.name.split('-')[0])?
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='operation_on_runways'
                label='Operation on Runways Less Than 45m Wide'
                value={opsReqData?.operation_on_runways || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('operation_on_runways', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>:null}
            {assetInfoData?.aircraft_type?.name.split('-') && ['B737','A320'].includes(assetInfoData?.aircraft_type?.name.split('-')[0])?
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='short_field_performance'
                label='Short Field Performance'
                value={opsReqData?.short_field_performance || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('short_field_performance', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>:null}
          </Grid>
        </>
        }
      </div>
      {isEdit ?
        <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
          <ul className="list-inline">
            <li className="list-inline-item">
              <Button onClick={() => { setError(''); setEdit(false); getOpsReq() }} color="primary" size='small' variant="outlined">Cancel</Button>
            </li>
            <li className="list-inline-item">
              <Button onClick={onEditOpsReq} color="primary" size='small' variant="contained">SAVE</Button>
            </li>
          </ul>
        </Paper> : null
      }
      {isLoading ? <PageLoader /> : null}
    </div>
  )
}

export default withRouter(TAOpsReq)
